import { useCallback, useEffect, useState } from 'react';
import { fetchCarAssetValueApi } from '@/api/carApi';
import { CarAssetValueData } from '@/types/api/carAssetValueApi';

interface UseCarAssetValueProps {
  tStockCarId: number | undefined;
  mlg?: number;
  exColId?: string;
}

export const useCarAssetValue = ({
  tStockCarId,
  mlg,
  exColId,
}: UseCarAssetValueProps) => {
  const [data, setData] = useState<CarAssetValueData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!tStockCarId) return;

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const params: { mlg?: number; ex_col_id?: string } = {};
      if (mlg != null) params.mlg = mlg;
      if (exColId != null) params.ex_col_id = exColId;

      const response = await fetchCarAssetValueApi(
        tStockCarId,
        Object.keys(params).length > 0 ? params : undefined,
      );
      const { data: resData } = response as unknown as {
        data: {
          data?: CarAssetValueData;
          success: boolean;
          error_message?: string;
        };
      };

      if (resData?.success && resData.data) {
        setData(resData.data);
      } else {
        setErrorMessage(
          resData?.error_message ?? '資産価値の取得に失敗しました',
        );
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('資産価値の取得に失敗しました');
    } finally {
      setIsLoading(false);
    }
  }, [tStockCarId, mlg, exColId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, isLoading, errorMessage } as const;
};
